<template>
  <div class="login-container">
    <div class="bg">
      <span class="slogen">Customs E 后台管理系统</span>
      <img src="@/assets/cas-bg.png" />
    </div>
    <div class="right">
      <el-form
        ref="loginForm"
        class="login-form"
        auto-complete="on"
        :rules="rules"
        :model="form"
      >
        <div class="title-container">
          <img src="@/assets/cas-logo.png" />
        </div>
        <el-form-item prop="username" style="position: relative">
          <el-input
            v-model="form.username"
            type="text"
            placeholder="请输入手机号或邮箱"
          >
            <img slot="prefix" style="margin-top: 10px;" src="@/assets/user.png" />
          </el-input>
        </el-form-item>
        <el-form-item prop="password1">
          <el-input
            v-model="form.password1"
            :type="showEye ? 'text' : 'password'"
            maxlength="20"
            placeholder="请输入密码"
            @keyup.enter.native="onLogin('loginForm')"
          >
            <img slot="prefix" style="margin-top: 10px;" src="@/assets/pwd.png" />
            <span slot="suffix" class="suffixEye" @click="showEye = !showEye">
              <svg-icon
                v-show="!showEye"
                className="openEye"
                iconClass="openEye"
              />
              <svg-icon
                v-show="showEye"
                className="closeEye"
                iconClass="closeEye"
              />
            </span>
          </el-input>
        </el-form-item>
        <!-- <el-form-item>
        <div class="flex">
          <div style="text-align: initial">
            <el-checkbox
              v-model="remember"
              :label="login.remember"
            ></el-checkbox>
          </div>
          <span style="cursor: pointer" @click="resetPassword">忘记密码</span>
        </div>
      </el-form-item> -->
        <div
          :loading="loading"
          class="btn"
          @click="onLogin('loginForm')"
        >{{ login.login }}</div
        >
      </el-form>
    </div>
  </div>
</template>
<script>
// import Tab from './components/Tab.vue'
import { sendPassCode, login } from '@/api/system'
import { getUserMenuPermission } from '@/api/setting'
import {
  getKey,
  firstPath,
  setCookie,
  getCookie,
  delCookie
} from '@/utils/common'
import { Encrypt } from '@/utils/secret'
import { isValidPhone, isValidEmail } from '@/utils/validate'
import { mapGetters } from 'vuex'
export default {
  name: 'Login',
  // components: { Tab },
  data() {
    return {
      form: {
        username: '',
        password1: '',
        password2: '',
        sendType: 0 // 0:电话 1:邮箱
      },
      login: {
        remember: '记住账号',
        login: '登  录',
        wechatLogin: '微信登录'
      },
      rules: {
        username: [
          { required: true, message: '请输入手机号或邮箱', trigger: 'blur' }
        ],
        password1: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        password2: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      remember: false,
      loading: false,
      tabData: ['账号登录', '验证码登录'],
      sendCode: '发送验证码',
      disabled: false,
      active: 1,
      fingerId: null,
      showEye: false
    }
  },
  computed: {
    ...mapGetters(['sign'])
  },
  async mounted() {
    const key = await getKey()
    this.fingerId = key
    this.getuserpwd()
  },
  methods: {
    onLogin(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          this.loading = true
          await this.$store.dispatch('getSign', this.fingerId)
          const param = {
            userAccount: this.form.username,
            password:
              this.active === 1
                ? Encrypt(this.form.password1, this.sign)
                : this.form.password2,
            type: this.active === 1 ? 0 : this.form.sendType ? 3 : 1,
            fingerId: this.fingerId
          }
          login(param).then((res) => {
            if (res.success) {
              this.loading = false
              if (this.remember) {
                // 保存帐号到cookie，有效期7天
                setCookie('username', this.form.username, 7)
              } else {
                delCookie('username')
              }
              getUserMenuPermission().then((res) => {
                if (!res.data || res.data.length === 0) {
                  this.$message.warning('用户暂未授权，请联系管理员')
                  return
                }
                this.$store.commit('ADD_INITROUTER', res.data)
                this.$store.dispatch('getUserInfo')
                this.$store.dispatch('addRouter').then(() => {
                  if (res.data.findIndex((a) => a.nameCH === '首页') > -1) {
                    this.$router.push('/home/workbench')
                  } else {
                    const path = firstPath(res.data)
                    this.$router.push(path)
                    console.log('path', path)
                  }
                })
              })
            } else {
              this.loading = false
              this.$message.error(res.errorMessage)
              this.$store.dispatch('getSign', this.fingerId)
            }
          })
        }
      })
    },
    getuserpwd() {
      // 如果缓存里面有记录，就直接获取登录
      if (getCookie('username') !== '') {
        this.form.username = getCookie('username')
        this.remember = true
      }
    },
    tabChange(index) {
      this.active = index
      this.$refs['loginForm'].resetFields()
    },
    register() {
      this.$router.push('/register')
    },
    sendECode() {
      if (!this.form.username) {
        this.$message.error(`未填写${this.form.sendType ? '邮箱' : '手机号'}`)
        return
      }
      if (!isValidPhone(this.form.username) && !this.form.sendType) {
        this.$message.error('请填写正确格式的手机')
        return
      } else if (!isValidEmail(this.form.username) && this.form.sendType) {
        this.$message.error('请填写正确格式的邮箱')
        return
      }
      const param = {
        number: this.form.username,
        passCodeType: 0, // 0: 登录 1：注册 2：忘记密码 3：核验 4 修改
        sendType: this.form.sendType
      }
      sendPassCode(param).then((res) => {
        if (res.success) {
          this.disabled = true
          let time = 60
          const timer = setInterval(() => {
            if (time > 0) {
              this.sendCode = `${time}秒重发`
              time--
            } else {
              clearInterval(timer)
              this.disabled = false
              this.sendCode = '发送验证码'
              time = 60
            }
          }, 1000)
        }
      })
    },
    resetPassword() {
      this.$router.push('/resetPassword')
    }
  }
}
</script>
<style lang="less" scoped>
.login-container {
  min-height: 100%;
  width: 100%;
  background: #ffffff;
  display: flex;
  .bg {
    width: 1064px;
    flex: 1;
    min-height: 100%;
    background: #262e47;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .slogen {
      position: absolute;
      height: 60px;
      font-family: Inter, Inter;
      font-weight: bold;
      font-size: 50px;
      line-height: 50px;
      color: #FFFFFF;
      text-align: left;
      font-style: normal;
      text-transform: none;
      top: 100px;
      left: 84px;
    }
  }
  .right {
    position: relative;
    width: 860px;
    margin: 0 auto;
    overflow: hidden;
  }
  .login-form {
    position: relative;
    width: 440px;
    margin: 0 auto;
    overflow: hidden;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: #889aa4;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    margin: 220px auto 88px;
    img {
      margin-left: 50px;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: #889aa4;
    cursor: pointer;
    user-select: none;
  }
  .btn {
    width: 440px;
    height: 56px;
    background: linear-gradient( 90deg, #5753E8 0%, #1E88E5 100%);
    box-shadow: 0px 4px 4px 0px rgba(26,51,106,0.25);
    border-radius: 14px 14px 14px 14px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 20px;
    color: #FFFFFF;
    line-height: 56px;
    text-align: center;
    cursor: pointer;
  }
}
</style>
